import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';

import { SharedPipeModule } from 'app/shared/pipes';

import { FusePreviewDialogComponent } from './preview-dialog.component';
@NgModule({
  declarations: [FusePreviewDialogComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    TranslateModule,
    SharedPipeModule,
  ],
  entryComponents: [FusePreviewDialogComponent],
})
export class FusePreviewDialogModule {}
